import { GET_USER_STATE, SAVE_USER_STATE, ADD_RECENT_NOTE, DELETE_RECENT_NOTE, RESET_USER_STATE, SET_CURRENT_COURSE_ID, SET_CURRENT_SECTION_ID } from '../types';
import defaultUserState from '../../config/defaultUserState.json';

export default function(userState = defaultUserState, action) {
  switch (action.type) {
    case GET_USER_STATE:
      return { ...userState, ...action.userState, loaded: true };
    case SAVE_USER_STATE:
      return action.userState;
    case ADD_RECENT_NOTE:
      return { ...userState, recentNotes: action.recentNotes };
    case DELETE_RECENT_NOTE:
      return { ...userState, recentNotes: action.recentNotes };
    case RESET_USER_STATE:
      return defaultUserState;
    case SET_CURRENT_COURSE_ID:
      return { ...userState, currentCourseId: action.currentCourseId }
    case SET_CURRENT_SECTION_ID:
      return { ...userState, currentSectionId: action.currentSectionId }
    default:
      return userState;
  }
}
